import { useBreakpoint } from "@highoutput/ui-components";

const desktopBreakpoints = "lg xl 2xl 3xl".split(/\s/);

export function useMarkdownStyle() {
  const breakpoint = useBreakpoint();
  const isDesktop = desktopBreakpoints.includes(breakpoint);

  return {
    "& > *": {
      fontFamily: "'Inter', sans-serif",
      color: "rgba(13,48,80,0.8)",
      fontSize: "18px",
      lineHeight: "28px",
    },
    a: {
      textDecoration: "underline",
    },
    "h1, h2, h3, h4, h5, h6, strong, b": {
      fontWeight: "bold",
    },
    h2: {
      fontSize: "32px",
      lineHeight: "36px",
      letterSpacing: "-0.015em",
      color: "rgb(13,48,80)",
      marginTop: "40px",
      ...(isDesktop && {
        lineHeight: "48px",
        marginTop: "80px",
        letterSpacing: "unset",
      }),
    },
    h3: {
      fontSize: "24px",
      lineHeight: "36px",
      color: "rgb(13,48,80)",
      marginTop: "40px",
    },
    h4: {
      color: "neutrals.800",
      fontSize: "20px",
      lineHeight: "32px",
    },
    /*
     * This are just BIGGER texts.
     * Can't use heading since they should be bold here
     * inorder not to be confusing
     *
     */
    ".caption": {
      fontSize: "18px",
      lineHeight: "28px",
      display: "block",
      textAlign: "unset",
      ...(isDesktop && {
        fontSize: "20px",
        lineHeight: "32px",
      }),
    },
    p: {
      marginTop: "16px",
    },
    img: {
      maxWidth: "full",
      display: "block",
      marginTop: "52px",
      marginBottom: "calc(58px - 16px)",
      ...(isDesktop && {
        marginTop: "80px",
        marginBottom: "calc(84px - 16px)",
      }),
    },
    "ul, ol": {
      paddingLeft: "16px",
      li: {
        marginLeft: "16px",
        marginTop: "16px",
        h4: {
          display: "inline-block",
          marginTop: "24px",
        },
      },
    },
    u: {
      textDecoration: "underline",
    },
    blockquote: {
      bgColor: "rgba(240,237,236,0.2)",
      padding: "24px 21px 40px 21px",
      borderLeft: "4px solid",
      borderColor: "v2.primary.default",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0.02em",
      marginTop: "40px",
      ...(isDesktop && {
        letterSpacing: "unset",
        fontSize: "20px",
        lineHeight: "32px 32px 40px 32px",
        marginTop: "64px",
        padding: "32px",
      }),
    },
    "iframe, video": {
      marginTop: "48px",
      maxWidth: "full",
    },
    block: {
      display: "block",
    },
  };
}
